import type { CountryHealthcare } from '../types';

const countryData: CountryHealthcare[] = [
  {
    id: '1',
    code: 'USA',
    country: 'United States of America',
    languages: ['English'],
    emergencyNumber: '911',
    healthMinistry: 'U.S. Department of Health & Human Services',
    healthMinistryUrl: 'https://www.hhs.gov/',
    travelAdvisoryBoard: 'U.S. Department of State',
    travelAdvisoryUrl: 'https://travel.state.gov/',
    insuranceProviders: [
      {
        name: 'Blue Cross Blue Shield',
        description: 'One of the largest health insurance providers in the USA',
        rating: 4.2,
        coverageAreas: ['Nationwide', 'International Travel'],
        website: 'https://www.bcbs.com/',
        specialties: ['Primary Care', 'Specialty Care', 'Mental Health', 'Prescription Drugs'],
        internationalCoverage: true
      },
      {
        name: 'UnitedHealthcare',
        description: 'Comprehensive health insurance coverage',
        rating: 4.0,
        coverageAreas: ['Nationwide'],
        website: 'https://www.uhc.com/',
        specialties: ['Medicare', 'Employer Plans', 'Individual Plans', 'Dental', 'Vision']
      },
      {
        name: 'Aetna',
        description: 'Wide network of healthcare providers',
        rating: 4.1,
        coverageAreas: ['Nationwide', 'International'],
        website: 'https://www.aetna.com/',
        specialties: ['Medical', 'Dental', 'Pharmacy', 'Behavioral Health']
      },
      {
        name: 'Cigna',
        description: 'Global health service company',
        rating: 4.0,
        coverageAreas: ['Nationwide', 'International'],
        website: 'https://www.cigna.com/',
        specialties: ['Global Health', 'Pharmacy Benefits', 'Mental Health']
      }
    ]
  },
  {
    id: '2',
    code: 'GBR',
    country: 'United Kingdom',
    languages: ['English'],
    emergencyNumber: '999',
    healthMinistry: 'Department of Health and Social Care',
    healthMinistryUrl: 'https://www.gov.uk/government/organisations/department-of-health-and-social-care',
    travelAdvisoryBoard: 'Foreign, Commonwealth & Development Office',
    travelAdvisoryUrl: 'https://www.gov.uk/foreign-travel-advice',
    insuranceProviders: [
      {
        name: 'Bupa UK',
        description: 'Leading private healthcare provider',
        rating: 4.4,
        coverageAreas: ['United Kingdom', 'International'],
        website: 'https://www.bupa.co.uk/',
        specialties: ['Private Healthcare', 'Dental', 'Mental Health']
      },
      {
        name: 'AXA Health',
        description: 'Comprehensive private medical insurance',
        rating: 4.3,
        coverageAreas: ['United Kingdom'],
        website: 'https://www.axahealth.co.uk/',
        specialties: ['Private Medical Insurance', 'Dental', 'Health Assessments']
      },
      {
        name: 'Vitality',
        description: 'Health and life insurance with rewards program',
        rating: 4.2,
        coverageAreas: ['United Kingdom'],
        website: 'https://www.vitality.co.uk/',
        specialties: ['Health Insurance', 'Life Insurance', 'Wellness Programs']
      }
    ]
  },
  {
    id: '3',
    code: 'CAN',
    country: 'Canada',
    languages: ['English', 'French'],
    emergencyNumber: '911',
    healthMinistry: 'Health Canada',
    healthMinistryUrl: 'https://www.canada.ca/en/health-canada.html',
    travelAdvisoryBoard: 'Government of Canada Travel',
    travelAdvisoryUrl: 'https://travel.gc.ca/',
    insuranceProviders: [
      {
        name: 'Sun Life Financial',
        description: 'Leading insurance provider in Canada',
        rating: 4.3,
        coverageAreas: ['Nationwide'],
        website: 'https://www.sunlife.ca/',
        specialties: ['Group Benefits', 'Health Insurance', 'Dental Care']
      },
      {
        name: 'Manulife',
        description: 'Comprehensive health and travel insurance',
        rating: 4.2,
        coverageAreas: ['Nationwide', 'International'],
        website: 'https://www.manulife.ca/',
        specialties: ['Travel Insurance', 'Health Insurance', 'Group Benefits']
      },
      {
        name: 'Great-West Life',
        description: 'Major insurance and wealth management company',
        rating: 4.1,
        coverageAreas: ['Nationwide'],
        website: 'https://www.greatwestlife.com/',
        specialties: ['Group Insurance', 'Individual Insurance', 'Investment']
      }
    ]
  },
  {
    id: '4',
    code: 'AUS',
    country: 'Australia',
    languages: ['English'],
    emergencyNumber: '000',
    healthMinistry: 'Department of Health',
    healthMinistryUrl: 'https://www.health.gov.au/',
    travelAdvisoryBoard: 'Smartraveller',
    travelAdvisoryUrl: 'https://www.smartraveller.gov.au/',
    insuranceProviders: [
      {
        name: 'Medibank',
        description: 'Major private health insurer',
        rating: 4.1,
        coverageAreas: ['Nationwide'],
        website: 'https://www.medibank.com.au/',
        specialties: ['Hospital Cover', 'Extras Cover', 'Overseas Cover']
      },
      {
        name: 'Bupa Australia',
        description: 'Comprehensive health insurance coverage',
        rating: 4.2,
        coverageAreas: ['Nationwide'],
        website: 'https://www.bupa.com.au/',
        specialties: ['Hospital Insurance', 'Extras Cover', 'Overseas Visitors Cover']
      },
      {
        name: 'HCF',
        description: "Australia's largest not-for-profit health fund",
        rating: 4.3,
        coverageAreas: ['Nationwide'],
        website: 'https://www.hcf.com.au/',
        specialties: ['Hospital Cover', 'Extras Cover', 'Ambulance Cover']
      }
    ]
  },
  {
    id: '5',
    code: 'DEU',
    country: 'Germany',
    languages: ['German'],
    emergencyNumber: '112',
    healthMinistry: 'Federal Ministry of Health',
    healthMinistryUrl: 'https://www.bundesgesundheitsministerium.de/',
    travelAdvisoryBoard: 'Federal Foreign Office',
    travelAdvisoryUrl: 'https://www.auswaertiges-amt.de/',
    insuranceProviders: [
      {
        name: 'TK (Techniker Krankenkasse)',
        description: 'Largest public health insurance provider',
        rating: 4.5,
        coverageAreas: ['Nationwide'],
        website: 'https://www.tk.de/',
        specialties: ['Public Health Insurance', 'Additional Insurance', 'Digital Health']
      },
      {
        name: 'AOK',
        description: 'Major public health insurance',
        rating: 4.3,
        coverageAreas: ['Nationwide'],
        website: 'https://www.aok.de/',
        specialties: ['Public Insurance', 'Family Coverage', 'Prevention Programs']
      },
      {
        name: 'Allianz Private Health Insurance',
        description: 'Leading private health insurer',
        rating: 4.4,
        coverageAreas: ['Nationwide', 'International'],
        website: 'https://www.allianz.de/',
        specialties: ['Private Insurance', 'Supplementary Coverage', 'International Coverage']
      }
    ]
  },
  {
    id: '6',
    code: 'JPN',
    country: 'Japan',
    languages: ['Japanese'],
    emergencyNumber: '119',
    healthMinistry: 'Ministry of Health, Labour and Welfare',
    healthMinistryUrl: 'https://www.mhlw.go.jp/',
    travelAdvisoryBoard: 'Ministry of Foreign Affairs',
    travelAdvisoryUrl: 'https://www.mofa.go.jp/',
    insuranceProviders: [
      {
        name: 'National Health Insurance (NHI)',
        description: 'Government health insurance system',
        rating: 4.6,
        coverageAreas: ['Nationwide'],
        website: 'https://www.mhlw.go.jp/english/',
        specialties: ['Basic Healthcare', 'Preventive Care', 'Hospital Coverage']
      },
      {
        name: 'Japan Health Insurance Association',
        description: 'Insurance for employees',
        rating: 4.5,
        coverageAreas: ['Nationwide'],
        website: 'https://www.kyoukaikenpo.or.jp/',
        specialties: ['Employee Insurance', 'Family Coverage', 'Medical Benefits']
      }
    ]
  },
  {
    id: '7',
    code: 'SGP',
    country: 'Singapore',
    languages: ['English', 'Mandarin', 'Malay', 'Tamil'],
    emergencyNumber: '995',
    healthMinistry: 'Ministry of Health',
    healthMinistryUrl: 'https://www.moh.gov.sg/',
    travelAdvisoryBoard: 'Ministry of Foreign Affairs',
    travelAdvisoryUrl: 'https://www.mfa.gov.sg/',
    insuranceProviders: [
      {
        name: 'MediShield Life',
        description: 'Universal health insurance scheme',
        rating: 4.5,
        coverageAreas: ['Nationwide'],
        website: 'https://www.moh.gov.sg/cost-financing/healthcare-schemes-subsidies/medishield-life',
        specialties: ['Basic Healthcare', 'Hospitalization', 'Chronic Conditions']
      },
      {
        name: 'Integrated Shield Plans',
        description: 'Enhanced coverage plans',
        rating: 4.4,
        coverageAreas: ['Nationwide'],
        website: 'https://www.moh.gov.sg/insurance/about-integrated-shield-plans',
        specialties: ['Private Hospital Coverage', 'Enhanced Benefits', 'Pre-existing Conditions']
      }
    ]
  }
];

export { countryData };
